import Vue from 'vue';
import moment from 'moment'

Vue.filter('formatDate', (value: Date | string | undefined, options?: { format: string }) => {
    if (value) {
      return moment(value).locale('nl').format(options?.format ?? 'dddd D MMMM')
    }
});
